import * as React from 'react'
import './ErrorPanel.scss'

interface UnexpectedErrorProps {
  errorMessage: string
  errorCode: string | null
}

export const UnexpectedError = ({ errorMessage, errorCode }: UnexpectedErrorProps) => {
  return (
    <div className='d-flex align-items-center auth-popup-container bg-white mt-8 text-white'>
      <div className='panel-width-480 w-100 h-100 py-3'>
        <div className='auth-popup-inner p-5'>
          <div className='auth-popup-content'>
            <i className='bi bi-x-octagon danger-icon d-flex justify-content-center align-items-center h-3rem w-3rem rounded-5 fs-4' />
            <span className='auth-popup-title'>An unexpected error has occurred</span>
            <span className='auth-popup-text'>Please try refreshing the page or contact our support team by sharing the following details.</span>

            <div className='error-description d-flex w-100 p-3 mt-5 rounded-3'>
              {errorCode ? `Error#${errorCode}: ` : ''}
              {errorMessage}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
